<template>
  <Doughnut
    :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :css-classes="cssClasses"
    :styles="styles"
    :width="width"
    :height="height"
  />
</template>

<script>
import { Doughnut } from "vue-chartjs/legacy";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
} from "chart.js";

import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
  ChartDataLabels
);

export default {
  name: "ElementDoughnutChart",
  components: {
    Doughnut,
  },
  props: {
    chartId: {
      type: String,
      default: "doughnut-chart",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    width: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 400,
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    onSelect: {
      type: Function,
    },
    selectedCapabilities: Array,
    // plugins: {
    //   type: Array,
    //   default: () => [],
    // },
  },
  data() {
    return {
      selectionElement: [],
      labelsDisplayChart: [
        "Advance Care\n Planning",
        "Recognise\n End of Life",
        "Assess\n Palliative\n Care Needs",
        "Provide\n Palliative Care",
        "Work Together",
        "Respond to\n Deterioration",
        "Manage Dying",
        "Bereavement",
      ],
      chartData: {
        labels: [
          "Advance Care Planning",
          "Recognise End of Life",
          "Assess Palliative Care Needs",
          "Provide Palliative Care",
          "Work Together",
          "Respond to Deterioration",
          "Manage Dying",
          "Bereavement",
        ],
        datasets: [
          {
            label: "tetstststs",
            backgroundColor: [
              "#5B647B",
              "#B34D48",
              "#1C6D85",
              "#596D5A",
              "#863C4C",
              "#70675D",
              "#257A67",
              "#754F68",
            ],
            data: [200, 200, 200, 200, 200, 200, 200, 200],
          },
        ],
      },
      chartOptions: {
        cutout: 75,
        responsive: true,
        maintainAspectRatio: false,
        offset: [0, 0, 0, 0, 0, 0, 0, 0],
        events: ["click", "mousemove"],
        onClick: (event, clickedElements, options) => {
          if (clickedElements[0]) {
            let chartData = options.config["_config"].data;
            let chartConfig = options.config["_config"].options;
            let idx = clickedElements[0]["index"];

            let label = chartData.labels[idx];
            let value = chartData.datasets[0].data[idx];

            if (chartConfig.offset[idx] === 0) {
              chartConfig.offset[idx] = 20;
              this.selectionElement.push(idx);
            } else {
              chartConfig.offset[idx] = 0;
              this.selectionElement = this.selectionElement.filter(
                (e) => e !== idx
              );
            }

            this.$emit("onSelect", this.selectionElement.sort());
            options.update();
            console.log(label, value);
          }
        },
        onHover: (e, chartElement) => {
          e.native.target.style.cursor = chartElement.length > 0 ? "pointer" : "auto";
        },
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            enabled: false,
          },
          datalabels: {
            textAlign: "center",
            borderColor: "white",
            color: "white",
            formatter: (value, context) => {
              return this.labelsDisplayChart[context.dataIndex];
            },
            anchor: "center",
            // align: (context) => {
            //   const { chart } = context;
            //   const offsetList = chart.config["_config"].options.offset;
            //   return offsetList[context.dataIndex] === 20 ? "end" : "center";
            // },
            offset: (context) => {
              const { chart } = context;
              const offsetList = chart.config["_config"].options.offset;
              return offsetList[context.dataIndex] === 20 ? -12 : 0;
            },
            // font: {
            //   weight: "bold",
            //   size: 20,
            // },
            font: (context) => {
              const { chart } = context;
              const offsetList = chart.config["_config"].options.offset;
              return {
                weight: "bold",
                size: offsetList[context.dataIndex] === 20 ? 12 : 10,
              };
            },
            padding: 0,
          },
        },
      },
      plugins: [
        {
          id: "elementChart",
          beforeDraw: (chart) => {
            let width = chart.width,
              height = chart.height,
              ctx = chart.ctx;

            ctx.restore();
            let fontSize = (height / 250).toFixed(2);
            ctx.font = "bold " + fontSize + "em sans-serif";
            ctx.textBaseline = "middle";
            ctx.fillStyle = "#127695";

            let text = "ELDAC",
              textX = Math.round((width - ctx.measureText(text).width) / 2) + 5,
              textY = height / 2 - 20;
            ctx.fillText(text, textX, textY);

            let text2 = "Care Model",
              text2X =
                Math.round((width - ctx.measureText(text).width) / 2) - 25,
              text2Y = height / 2 + 20;

            ctx.fillText(text2, text2X, text2Y);

            ctx.save();
          },
        },
      ],
    };
  },
  methods: {
    filterSelectedCapabilities(selectedCapabilities) {
      selectedCapabilities.forEach((selectedCapabilitie) => {
        this.chartOptions.offset = this.chartOptions.offset.map(
          (offsetItem, index) => {
            return index === selectedCapabilitie ? 20 : offsetItem;
          }
        );
      });
    },
  },
  mounted() {
    this.selectionElement = this.selectedCapabilities || [];
    if (this.selectionElement) {
      this.filterSelectedCapabilities(this.selectionElement);
    }
  },
};
</script>
